import { GETWORKSPACEDETAILS_FAIL, GETWORKSPACEDETAILS_SUCCESS } from '../actionTypes';

const initialState = {
  user: null,
  expenseVoucherFile: null,
};

const getWorkspaceDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETWORKSPACEDETAILS_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload.user,
        expenseVoucherFile: action.payload.expenseVoucherFile || null,
      };
    case GETWORKSPACEDETAILS_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        expenseVoucherFile: null,
      };
    default:
      break;
  }

  return state;
};

export default getWorkspaceDetailsReducer;
